import {configurePlatform} from '@tenant/core/platform';
import {validatePlatform} from '@tenant/core/platform/contract';
import webPlatform from './platform';

configurePlatform(webPlatform);

if (process.env.NODE_ENV !== 'production') {
  const problems = validatePlatform(webPlatform);
  if (problems.length > 0) {
    // eslint-disable-next-line no-console
    console.error('[platform] incomplete web adapter:', problems.join(', '));
  }
}
